import { Flame, Snowflake } from "lucide-react";

export const tempColor = (t) => {
  if (t >= 100) return "#FF3B30";
  if (t > 0) return "#FF8A3D";
  if (t < 0) return "#007AFF";
  return "#94A3B8";
};

export const TemperatureBadge = ({ temperature, className = "", size = "md" }) => {
  const color = tempColor(temperature);
  const Icon = temperature < 0 ? Snowflake : Flame;
  const pad = size === "lg" ? "px-4 py-1.5 text-2xl" : "px-3 py-1 text-lg";
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full text-white font-outfit font-black tracking-tight shadow-sm ${pad} ${className}`}
      style={{ backgroundColor: color }}
      data-testid="deal-temperature-badge"
    >
      <Icon className={size === "lg" ? "h-5 w-5" : "h-4 w-4"} strokeWidth={2.5} />
      {temperature}°
    </span>
  );
};

export default TemperatureBadge;
